// extracted by mini-css-extract-plugin
export default {"border":"Datatable_border_n8GYV"};